import {useEventListener, useDebounceFn, tryOnScopeDispose} from '@vueuse/core'

const getViewportHeight = () => Math.min(window.innerHeight, window.visualViewport?.height ?? Infinity)

const applyHeight = () => {
  document.documentElement.style.setProperty('--height', `${getViewportHeight()}px`)
}

// iOS Chrome computes 100vh/100dvh on cold-launch (e.g. deep link from
// Mail/SMS) before its dynamic toolbar settles, and never relayouts unless a
// reflow is forced (switching tabs). Track the real viewport height in JS and
// re-check shortly after load to correct it without relying on that gesture.
export const useViewportHeightCallback = () => {
  const update = useDebounceFn(applyHeight, 50)

  applyHeight()
  const lateChecks = [setTimeout(applyHeight, 300), setTimeout(applyHeight, 1000)]
  tryOnScopeDispose(() => lateChecks.forEach(clearTimeout))

  useEventListener(window, 'resize', update)
  useEventListener(window, 'orientationchange', update)
  if (window.visualViewport) {
    useEventListener(window.visualViewport, 'resize', update)
  }
}
